﻿import { DollarSign, TrendingDown, TrendingUp, Wallet } from "lucide-react";

export function FinancialMetrics({
  currentBalance,
  initialBalance,
  grossRevenue,
  totalExpenses,
  netMargin,
}: {
  currentBalance: number;
  initialBalance: number;
  grossRevenue: number;
  totalExpenses: number;
  netMargin: string | number;
}) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 opacity-100 transition-opacity">
      <div className="bg-slate-800/80 backdrop-blur border border-slate-700 rounded-xl p-5 shadow-lg">
        <div className="flex justify-between items-start">
          <div>
            <p className="text-slate-400 text-sm font-medium">
              Fundo de Gaveta + Saldo
            </p>
            <h3
              className={`text-3xl font-bold mt-2 ${
                currentBalance >= 0 ? "text-emerald-400" : "text-red-400"
              }`}
            >
              R$ {(currentBalance + initialBalance).toFixed(2)}
            </h3>
          </div>
          <div className="p-3 bg-emerald-500/10 rounded-lg">
            <Wallet className="text-emerald-400" size={24} />
          </div>
        </div>
      </div>

      <div className="bg-slate-800/80 backdrop-blur border border-slate-700 rounded-xl p-5 shadow-lg">
        <div className="flex justify-between items-start">
          <div>
            <p className="text-slate-400 text-sm font-medium">
              Receita Bruta (Entradas)
            </p>
            <h3 className="text-3xl font-bold mt-2 text-white">
              R$ {grossRevenue.toFixed(2)}
            </h3>
          </div>
          <div className="p-3 bg-blue-500/10 rounded-lg">
            <TrendingUp className="text-blue-400" size={24} />
          </div>
        </div>
      </div>

      <div className="bg-slate-800/80 backdrop-blur border border-slate-700 rounded-xl p-5 shadow-lg">
        <div className="flex justify-between items-start">
          <div>
            <p className="text-slate-400 text-sm font-medium">
              Total de Despesas
            </p>
            <h3 className="text-3xl font-bold mt-2 text-red-400">
              R$ {totalExpenses.toFixed(2)}
            </h3>
          </div>
          <div className="p-3 bg-red-500/10 rounded-lg">
            <TrendingDown className="text-red-400" size={24} />
          </div>
        </div>
      </div>

      <div className="bg-slate-800/80 backdrop-blur border border-slate-700 rounded-xl p-5 shadow-lg">
        <div className="flex justify-between items-start">
          <div>
            <p className="text-slate-400 text-sm font-medium">
              Margem Líquida Estimada
            </p>
            <h3
              className={`text-3xl font-bold mt-2 ${
                Number(netMargin) >= 0 ? "text-cyan-400" : "text-red-400"
              }`}
            >
              {netMargin}%
            </h3>
          </div>
          <div className="p-3 bg-cyan-500/10 rounded-lg">
            <DollarSign className="text-cyan-400" size={24} />
          </div>
        </div>
      </div>
    </div>
  );
}
